import axios from 'axios';
import router from '@/router';

const API_KEY = process.env.VUE_APP_API_KEY;
const api = axios.create({
    baseURL: `${process.env.VUE_APP_URL_API}`,
    headers: {
        'x-api-key': API_KEY,
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use(
    (config) => {
        const user = JSON.parse(localStorage.getItem('userData'));

        if (user && user.token) {
            config.headers['Authorization'] = `Bearer ${user.token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('userData');
            router.push({ name: 'login' });
        }
        return Promise.reject(error);
    }
);

export default api;

// ========================
// V2 — Prestadores Presenciais
// ========================

export const searchProviders = (params) =>
  api.get('/providers/search', { params })

export const searchCategories = (params) =>
  api.get('/providers/search-categories', { params })

export const getProviderProfile = (hash) =>
  api.get(`/providers/${hash}/profile`)

export const getProviderServices = (hash) =>
  api.get(`/providers/${hash}/services`)

export const getProviderAvailability = (hash, params) =>
  api.get(`/providers/${hash}/availability`, { params })

export const updateProviderLocation = (data) =>
  api.put('/provider/location', data)

// Serviços do prestador (autenticado)
export const listMyServices = () =>
  api.get('/provider/services')

export const createService = (data) =>
  api.post('/provider/services', data)

export const updateService = (id, data) =>
  api.put(`/provider/services/${id}`, data)

export const deleteService = (id) =>
  api.delete(`/provider/services/${id}`)

// Disponibilidade do prestador (autenticado)
export const getMyAvailability = () =>
  api.get('/provider/availability')

export const saveMyAvailability = (data) =>
  api.put('/provider/availability', data)

export const listMyBlocks = (params) =>
  api.get('/provider/blocks', { params })

export const createBlock = (data) =>
  api.post('/provider/blocks', data)

export const deleteBlock = (id) =>
  api.delete(`/provider/blocks/${id}`)

// Agendamentos (autenticado)
export const createAppointment = (data) =>
  api.post('/appointments', data)

export const getContractorAppointments = (params) =>
  api.get('/appointments/contractor', { params })

export const getProviderAppointments = (params) =>
  api.get('/appointments/provider', { params })

export const getAppointment = (id) =>
  api.get(`/appointments/${id}`)

export const confirmAppointment = (id) =>
  api.put(`/appointments/${id}/confirm`)

export const completeAppointment = (id) =>
  api.put(`/appointments/${id}/complete`)

export const cancelAppointment = (id, data) =>
  api.put(`/appointments/${id}/cancel`, data)

export const createAppointmentPix = (id) =>
  api.post(`/appointments/${id}/payment/pix`)

export const createAppointmentCheckout = (id) =>
  api.post(`/appointments/${id}/payment/checkout`)

export const getAppointmentPaymentStatus = (id) =>
  api.get(`/appointments/${id}/payment/status`)

export const reviewAppointment = (id, data) =>
  api.post(`/appointments/${id}/review`, data)